/* eslint-disable i18n/no-russian-character */
import ruComponents from "./ru.components";
import ruPages from "./ru.pages";
import ruPipes from "./ru.pipes";
import ruPlural from "./ru.plural";
import ruTables from "./ru.tables";
import ruSystem from "./ruSystem";

const ru = {
    localeName: "ru-RU",
    localNameShort: "ru",
    address: "Адрес",
    and: "и",
    system: ruSystem,
    components: ruComponents,
    pages: ruPages,
    pipes: ruPipes,
    plural: ruPlural,
    tables: ruTables,
    accessDenied: "Доступ запрещен",
    actions: "Действия",
    add: "Добавить",
    apply: "Применить",
    all: "Все",
    back: "Назад",
    cancel: "Отмена",
    category: "Категория",
    close: "Закрыть",
    cntShort: "шт.",
    comment: "Комментарий",
    complete: "Завершить",
    confirm: "Подтвердить",
    createdDate: "Дата создания",
    createdUser: "Создал",
    date: "Дата",
    dateRange: "Период",
    delete: "Удалить",
    department: "Подразделение",
    description: "Описание",
    download: "Скачать",
    deadline: "Крайний срок",
    digit: "Число",
    edit: "Редактировать",
    email: "E-mail",
    error: "Ошибка",
    example: "Образец",
    employee: "Должность",
    filters: "Фильтры",
    from: "с",
    fullName: "ФИО",
    go: "Перейти",
    image: "Изображение",
    id: "ID",
    iterate: "Повторять",
    loading: "Загрузка...",
    money: "₽",
    moneyShort: "руб.",
    moneyLocal: "Кофекоин",
    months: {
        january: "Январь",
        february: "Февраль",
        march: "Март",
        april: "Апрель",
        may: "Май",
        june: "Июнь",
        july: "Июль",
        august: "Август",
        september: "Сентябрь",
        october: "Октябрь",
        november: "Ноябрь",
        december: "Декабрь",
    },
    name: "Наименование",
    never: "Никогда",
    next: "Далее",
    no: "Нет",
    notFound: "Не найдено",
    ok: "OK",
    open: "Открыть",
    or: "или",
    order: "Порядок",
    orderNumber: "№%s",
    path: "Путь",
    password: "Пароль",
    paste: "Вставить",
    photo: "Фото",
    phone: "Номер телефона",
    period: "Период",
    refresh: "Обновить",
    region: "Регион",
    report: "Отчет",
    record: "Запись",
    result: "Результат",
    reset: "Сбросить",
    role: "Роль",
    save: "Сохранить",
    search: "Поиск",
    customer: "Поставщик",
    inn: "ИНН",
    send: "Отправить",
    selectValue: "Укажите значение",
    sec: "сек.",
    show: "Показать",
    start: "Начало",
    status: "Статус",
    s_of_s: "%s из %s",
    tags: "Теги",
    to: "до",
    type: "Тип",
    tradePoint: "Кофейня",
    tradePoints: "Кофейни",
    title: "Название",
    timeZone: "Часовой пояс",
    unknown: "Неизвестно",
    updatedDate: "Дата последнего изменения",
    updatedUser: "Редактировал",
    user: "Пользователь",
    userSex: "Пол",
    url: "Ссылка",
    view: "Просмотр",
    video: "Видео",
    value: "Значение",
    warning: "Внимание",
    yes: "Да",
    you: "Вы",
    preventive: "Профилактическое",
    repair: "Ремонт",
    replacement: "Замена",
    inspection: "Осмотр",

    weekDays: {
        monday: "Понедельник",
        tuesday: "Вторник",
        wednesday: "Среда",
        thursday: "Четверг",
        friday: "Пятница",
        saturday: "Суббота",
        sunday: "Воскресенье",
    },
    orderItemIikoGuidError: "(отсутствует GUID, отправить в iiko невозможно)",
};
export default ru;
